import empty_table from '../assets/images/empty_table.png';
import searchicon from '../assets/images/search.png';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMessage } from '../slices/messages';
import { allPost } from '../slices/posts';
import Pagination from './dt/Pagination';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Posts = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t} = useTranslation();
    const { allposts } = useSelector((state) => state.posts);
    const { user} = useSelector((state) => state.auth);

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const [activeLang, setActiveLang] = useState(currentLang);

    const [currentPage, setCurrentPage] = useState(1);
    const [defaultSort, setSort] = useState({ 'sort_column': 'created_at', 'sort_type': 'desc' });
    const [search, setSearch] = useState("");

    let PageSize = 20;

    const changePageSize = (pageNumber) => {
        setSort({ 'sort_column': 'created_at', 'sort_type': 'desc' });
        setCurrentPage(pageNumber);
    }

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        dispatch(clearMessage());

        let tmpVar = {
            page: currentPage,
            sort: defaultSort,
            activeLang: activeLang,
            search: search,
            status: '1'
        };

        dispatch(allPost(tmpVar));
    }, [defaultSort, currentPage, search]);

    const viewPost = (id) => {
        navigate('/post/view/' + id);
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="row">
                    <div className='col-md-6'>
                        <div className='section-title' id="heading_title">
                            <h1><span className='font-color-1'>{t('allPosts')}</span></h1>
                            <p>{t('approved_post')}</p>
                            <br />
                        </div>
                    </div>
                    <div className='col-md-6 table-search-area mt-2'>
                        <div className='table-search'>
                            <input type='search' className='form-control' placeholder={t('search_here')} onChange={e => setSearch(e.target.value)}/>
                            <img src={searchicon} />
                        </div>
                    </div>
                    {
                        allposts != null && allposts.total > 0 ?
                            allposts?.res.map((item, index) => {
                                return (
                                    <div className="col-md-3 itemBox mb-4" onClick={() => viewPost(item.id)} key={item.id}>
                                        <div className="card">
                                            <div className="card-body p-0">
                                                <img src={item.image_path} class="mobile-img"  width={260} height={205} />
                                            </div>
                                            <div className="card-footer post-footer">
                                                <h5 className='mb-0 gallery-title'>{item.title}</h5>
                                                <h6 className='mb-0'>{item.created_at}</h6>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                            :
                            <div className='emptyTable'>
                                <img src={empty_table} />
                                <h5 className='mt-2-new'>{t('noData')}</h5>
                            </div>
                    }

                    <div className='col-md-12'>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={allposts ? allposts.total : 1}
                            pageSize={PageSize}
                            onPageChange={page => changePageSize(page)}
                        />
                    </div>

                </div>
            </section>
        </div>
    );
}
export default Posts;